import { render, staticRenderFns } from "./complexItem.vue?vue&type=template&id=00bd17c4&scoped=true&"
import script from "./complexItem.vue?vue&type=script&lang=js&"
export * from "./complexItem.vue?vue&type=script&lang=js&"
import style0 from "./complexItem.vue?vue&type=style&index=0&id=00bd17c4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00bd17c4",
  null
  
)

export default component.exports